import { useRef, useState } from "react";

export default function Built() {
  const scrollContainerRef = useRef(null);
  const desktopScrollRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [desktopDragging, setDesktopDragging] = useState(false);
  const [desktopStartX, setDesktopStartX] = useState(0);
  const [desktopScrollLeft, setDesktopScrollLeft] = useState(0);

  return (
    <div className="bg-white py-20 lg:py-32 px-6 xxs:px-6 xs:px-10 sm:px-10 md:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col gap-12 lg:gap-16">
          {/* Main Heading */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left w-7xl">
            <h1 className="text-5xl xxs:text-[55px] lg:text-[80px] xl:text-[80px] 1xl:text-[80px] 4xl:text-[90px] font-normal text-black leading-tight enfinity-header-font" style={{ lineHeight: "1.2" }}>
              <p className="mb-2">
                <span>Built from </span>
                <span
                  className="bg-clip-text text-transparent"
                  style={{
                    backgroundImage:
                      "linear-gradient(to right, #00d115, #00b0ff, #9c44e9)",
                  }}
                >
                  experience
                </span>
                <span>,</span>
              </p>
              <p>driven by passion</p>
            </h1>
          </div>

          {/* First Paragraph - Mobile Only */}
          <div className="flex flex-col items-start text-left lg:hidden">
            <p className="text-xl xxs:text-[1rem] lg:text-xl xl:text-[24px] 1xl:text-[24px] 2xl:text-[24px] 4xl:text-[24px] font-normal text-black leading-[34px] enfinity-subtext-font" style={{ lineHeight: "1.3" }}>
              Enfinity was born from a simple realization: creators needed more than just a platform—they needed a partner. We saw talented creators struggling with payment delays, content theft, limited distribution, and the overwhelming complexity of team management.
            </p>
          </div>

          {/* Timeline Image - Mobile (Scrollable) */}
          <div className="relative -mx-6 xxs:-mx-2 xs:-mx-2 sm:-mx-8 md:-mx-12 lg:hidden -mt-8">
            <style>{`
              .built-scroll-container::-webkit-scrollbar,
              .built-desktop-scroll::-webkit-scrollbar {
                display: none;
              }
            `}</style>
            <div className="mx-auto max-w-7xl 4xl:max-w-full">
              <div
                ref={scrollContainerRef}
                className="built-scroll-container relative overflow-x-auto pb-8 cursor-grab active:cursor-grabbing select-none"
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
                onMouseDown={(e) => {
                  setIsDragging(true);
                  setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
                  setScrollLeft(scrollContainerRef.current.scrollLeft);
                }}
                onMouseLeave={() => setIsDragging(false)}
                onMouseUp={() => setIsDragging(false)}
                onMouseMove={(e) => {
                  if (!isDragging) return;
                  e.preventDefault();
                  const x = e.pageX - scrollContainerRef.current.offsetLeft;
                  const walk = (x - startX) * 2; // Scroll speed multiplier
                  scrollContainerRef.current.scrollLeft = scrollLeft - walk;
                }}
              >
                <div className="inline-flex px-6 xxs:px-2 xs:px-2 sm:px-8 md:px-12">
                  <img
                    src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/built-animation.svg"
                    alt="Enfinity Timeline"
                    className="h-auto object-contain"
                    style={{ width: 'auto', minWidth: '800px', maxWidth: 'none' }}
                    draggable={false}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Desktop Layout */}
          <div className="hidden lg:block -mt-8 lg:-mt-12">
            {/* First Paragraph */}
            <div className="flex flex-col items-start text-left mb-8">
              <p className="text-xl xl:text-[24px] 1xl:text-[24px] 2xl:text-[24px] 4xl:text-[24px] font-normal text-black leading-[34px] enfinity-subtext-font lg:max-w-[520px] xl:max-w-[680px] pt-12 lg:pt-8" style={{ lineHeight: "1.3" }}>
                Enfinity was born from a simple realization: creators needed more than just a platform—they needed a partner. We saw talented creators struggling with payment delays, content theft, limited distribution, and the overwhelming complexity of team management.
              </p>
            </div>

            {/* Timeline - Desktop (scrollable, larger image) */}
            <div className="relative -mx-4 lg:-mx-6 xl:-mx-8 4xl:-mx-10 -mt-20 lg:-mt-28">
              <div className="max-w-7xl xl:max-w-full 4xl:max-w-full mx-auto">
              <div
                ref={desktopScrollRef}
                className="built-desktop-scroll overflow-x-auto cursor-grab active:cursor-grabbing select-none pb-4 -mx-4 px-4"
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
                onMouseDown={(e) => {
                  setDesktopDragging(true);
                  setDesktopStartX(e.pageX - desktopScrollRef.current.offsetLeft);
                  setDesktopScrollLeft(desktopScrollRef.current.scrollLeft);
                }}
                onMouseLeave={() => setDesktopDragging(false)}
                onMouseUp={() => setDesktopDragging(false)}
                onMouseMove={(e) => {
                  if (!desktopDragging) return;
                  e.preventDefault();
                  const x = e.pageX - desktopScrollRef.current.offsetLeft;
                  const walk = (x - desktopStartX) * 2;
                  desktopScrollRef.current.scrollLeft = desktopScrollLeft - walk;
                }}
              >
                <div className="inline-flex justify-center min-w-full">
                  <img
                    src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/built-animation.svg"
                    alt="Enfinity Timeline"
                    className="h-auto object-contain max-w-none lg:min-w-[1800px] lg:w-[1900px] xl:min-w-[1800px] xl:w-[2100px] 2xl:min-w-[2200px] 2xl:w-[2400px] 4xl:w-[2000px]"
                    draggable={false}
                  />
                </div>
              </div>

              {/* Second Paragraph - Below SVG on the right */}
              <div className="flex justify-end mt-8">
                <div className="flex flex-col items-start text-left max-w-[573px]">
                  <p className="text-xl xl:text-[24px] 1xl:text-[24px] 2xl:text-[24px] 4xl:text-[24px] font-normal text-black leading-[34px] enfinity-subtext-font -mt-12" style={{ lineHeight: "1.3" }}>
                    Today, we're proud to serve thousands of creators across the globe, helping them unlock their full potential and build sustainable, thriving businesses.
                  </p>
                </div>
              </div>

              {/* Timeline Milestones */}
              
              </div>
            </div>
          </div>

          {/* Second Paragraph - Mobile Only */}
          <div className="flex flex-col items-start text-left lg:hidden">
            <p className="text-xl xxs:text-[1rem] lg:text-xl xl:text-[24px] 1xl:text-[24px] 2xl:text-[24px] 4xl:text-[24px] font-normal text-black leading-[34px] enfinity-subtext-font" style={{ lineHeight: "1.3" }}>
              Today, we're proud to serve thousands of creators across the globe, helping them unlock their full potential and build sustainable, thriving businesses.
            </p>
          </div>
          
        </div>
      </div>
    </div>
  );
}

